/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{C02B1FD2-26B0-42F4-8271-79DFBD564892}",
  "sitecoreApiHost": "",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "graphQLEndpoint": "/sitecore/api/graph/edge?sc_apikey={C02B1FD2-26B0-42F4-8271-79DFBD564892}"
};